import { Panel } from 'config/types';
import { getApiItems } from 'store/hooks/useApiItems';

/**
 * Returns a panel configuration based on panel id and panel list
 * @param panelId
 * @param panelList
 * @returns
 */
export const getPanelOptions = (panelId: string, panelList: Panel[]) => {
  const baseOptions = panelList.find((p) => panelId === p.id);
  if (baseOptions) {
    const apiOptions = getApiItems().solarPanels.find(
      (p) => p.type === baseOptions.type
    );
    if (apiOptions) {
      return {
        ...baseOptions,
        apiId: apiOptions.id,
        size: {
          w: apiOptions.size.width / 1000,
          h: apiOptions.size.height / 1000,
        },
        power: apiOptions.power / 1000,
        prices: apiOptions.prices,
      };
    }
  }
  return undefined;
};
